<td-wb-tooltip-button [ariaLabel]="'tdWb.lti.dashboard.goals.MORE_INFORMATION' | translate"
                      [attr.aria-describedby]="ariaDescribedBy()"
                      [tdWbOverlayToggle]="goalStatusTooltip"
                      [tdWbOverlayPosition]="position()"
                      tdWbOverlaySize="medium" />
<ng-template #goalStatusTooltip>
  <td-wb-overlay>
    <div class="td-wb-body-small td-wb-p"
         [translate]="'tdWb.lti.dashboard.goals.'+ goalStatus()"></div>
  </td-wb-overlay>
</ng-template>
